import React from 'react';
import { compose, branch, renderNothing } from 'recompose'
import MainHeader from 'components/headers/MainHeader'
import FormInput from 'components/forms/bases/FormInput';
import FormTarget from 'components/forms/FormTarget';
import FormLanguage from 'components/forms/FormLanguage';
import FormLink from 'components/forms/FormLink';
import Image from 'components/images/Image'
import FormImage from 'components/forms/image/FormImage'

const styles = {
  content: {
    marginLeft: 20,
  },
  all: {
    padding: '10px',
    paddingTop: 0,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 40,
  },
  button: {
    textAlign: 'right',
  },
};

const MenuEditor = compose(
  branch(
    (props) => !props.menu,
    renderNothing
  )
)(
  ({
    onChange,
    menu,
    menu: {
      image,
      imageLink,
      imageTarget,
      name,
      url,
      target,
    },
  }) => {
    const handleChange = (val, key) => onChange(Object.assign({}, menu, {
      [key]: val,
      ...key === 'name' ? { title: `${val.en} / ${val.th}` } : {},
    }));
    return (
      <div
        style={styles.all}
      >
        <MainHeader>Image Settings</MainHeader>
        <div style={styles.content}>
          <FormImage>
            <FormImage.Column width={12}>
              <FormImage.Image src={image}/>
            </FormImage.Column>
            <FormImage.Column width={12}>
              <FormImage.Source
                value={image}
                onChange={(val) => handleChange(val, 'image')}
              />
              <FormImage.Link value={imageLink} onChange={val => handleChange(val, 'imageLink')} />
              <FormImage.Target value={imageTarget} onChange={val => handleChange(val, 'imageTarget')} />
            </FormImage.Column>
          </FormImage>
        </div>
        <MainHeader>Text Settings</MainHeader>
        <div style={styles.content}>
          <FormLanguage label="Language" value={name} onChange={val => handleChange(val, 'name')} />
          <FormLink value={url} onChange={val => handleChange(val, 'url')} />
          <FormTarget value={target} onChange={val => handleChange(val, 'target')} />
        </div>
      </div>
    );
  }
);

MenuEditor.propTypes = {};
MenuEditor.defaultProps = {};

export default MenuEditor;



// WEBPACK FOOTER //
// ./src/pages/Menus/children/MenuEditor.js